export default __webpack_public_path__ + "static/media/locks.633029ee.svg";